
import api from './axiosConfig';

export interface WeekOffRuleDto {
  dayOfWeek: number; // 1=Monday, 7=Sunday
  weekOfMonth: number;
}

export interface CalendarDayStatusDto {
  date: string;
  status: string; // Present, Absent, Leave, CompOff, Holiday, WeekOff
  details?: string;
  checkInTime?: string | null;
  checkOutTime?: string | null;
}

export const calendarApi = {
  getEmployeeCalendarStatus: async (
    employeeId: string,
    fromDate: string,
    toDate: string
  ): Promise<CalendarDayStatusDto[]> => {
    const response = await api.get<CalendarDayStatusDto[]>(
      '/calendar/employee-status',
      { params: { employeeId, fromDate, toDate } }
    );
    return response.data;
  },
  getEmployeeWeekOffRules: async (employeeId: string): Promise<WeekOffRuleDto[]> => {
    const response = await api.get<WeekOffRuleDto[]>(`/workweek/employee/${employeeId}/weekoffrules`);
    return response.data;
  },
};
